import { createContext, ReactNode } from 'react';
import useThunkReducer, { ThunkDispatch } from 'react-hook-thunk-reducer';

import BP42Analytics, { analytics } from '@r1-frontend/bp42/analytics/BP42Analytics';
import BP42Callback, { callbacks } from '@r1-frontend/bp42/helpers/BP42Callback';

import initialState, { BP42InitialState } from './reducer/initialState';
import reducer, { BP42Actions } from './reducer';

export type BP42CtxDispatch = ThunkDispatch<BP42InitialState, BP42Actions>

export type TCtx = {
    state: BP42InitialState,
    dispatch: BP42CtxDispatch,
    debugMode?: boolean,
    analytics: BP42Analytics,
    callbacks: BP42Callback,
    csrf: string,
}

export const BP42Ctx = createContext<TCtx>({
    state: initialState,
    dispatch: () => null,
    debugMode: false,
    analytics,
    callbacks,
    csrf: '',
});

const BP42Context = ({ children, csrf, debugMode = false }: { children: ReactNode, csrf: string, debugMode?: boolean }): JSX.Element => {
    const [state, dispatch] = useThunkReducer<BP42InitialState, BP42Actions>(reducer, initialState);

    debugMode && console.log(state);

    return <BP42Ctx.Provider value={{ state, dispatch, debugMode, analytics, callbacks, csrf }}>
        {children}
    </BP42Ctx.Provider>;
};

export default BP42Context;
